import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import HomeownerOnboarding from './pages/HomeownerOnboarding';
import ContractorOnboarding from './pages/ContractorOnboarding';
import HomeownerDashboard from './pages/HomeownerDashboard';
import ContractorDashboard from './pages/ContractorDashboard';
import SendADoe from './pages/SendADoe';
import RequestDetail from './pages/RequestDetail';
import Chat from './pages/Chat';
import ContractorProfile from './pages/ContractorProfile';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Security from './pages/legal/Security';
import ContractorAgreement from './pages/legal/ContractorAgreement';
import ConsumerAgreement from './pages/legal/ConsumerAgreement';

function ProtectedRoute({ children, allowedRoles }: { children: React.ReactNode; allowedRoles?: string[] }) {
  const { user, loading } = useAuth();

  if (loading) return <div className="loading-screen"><div className="doe-spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" />;

  return <>{children}</>;
}

export default function App() {
  const { user } = useAuth();

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/security" element={<Layout><Security /></Layout>} />
      <Route path="/contractor-agreement" element={<Layout><ContractorAgreement /></Layout>} />
      <Route path="/consumer-agreement" element={<Layout><ConsumerAgreement /></Layout>} />
      <Route path="/contractors/:id" element={<Layout><ContractorProfile /></Layout>} />

      {/* Onboarding */}
      <Route path="/onboarding/homeowner" element={<ProtectedRoute><HomeownerOnboarding /></ProtectedRoute>} />
      <Route path="/onboarding/contractor" element={<ProtectedRoute><ContractorOnboarding /></ProtectedRoute>} />

      {/* Homeowner */}
      <Route path="/dashboard" element={
        <ProtectedRoute allowedRoles={['homeowner']}>
          <Layout><HomeownerDashboard /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/send-a-doe" element={
        <ProtectedRoute allowedRoles={['homeowner']}>
          <Layout><SendADoe /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/requests/:id" element={
        <ProtectedRoute>
          <Layout><RequestDetail /></Layout>
        </ProtectedRoute>
      } />

      {/* Contractor */}
      <Route path="/contractor-dashboard" element={
        <ProtectedRoute allowedRoles={['contractor']}>
          <Layout><ContractorDashboard /></Layout>
        </ProtectedRoute>
      } />

      {/* Shared */}
      <Route path="/chat" element={
        <ProtectedRoute>
          <Layout><Chat /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/chat/:conversationId" element={
        <ProtectedRoute>
          <Layout><Chat /></Layout>
        </ProtectedRoute>
      } />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
